module.exports = __webpack_public_path__ + "static/media/john.5bee22de.jpg";